/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa loan calculator
 *
 */
Intesa.LoanCalculatorBIBCombined = function() {

	/**
	 * Local variables
	 *
	 */
	var loan = this;
	var development = false;
	var invalidJsonFiles = false;
	var genericSettings = {};
	var calculatorLabels = {};
	var lang = $('html')[0].getAttribute('lang');
	/**
	 * Global variables
	 *
	 */
	this.MAX_ITERATIONS = 50;
	this.activeCalculator = null;
	this.activeVariant = {};
	this.activeMortgage = {};
	this.activeCurrency = {};
	this.activeInterestType = {};
	this.errorState = false;
	this.defaultEducation = null;
	// values
	this.loanAmount = 0;
	this.firstInterestRate = 0;
	this.firstInterestRateCode = '';
	this.secondInterestRate = 0;
	this.tenor = 0;
	this.tenorUnit = null;
	this.firstMonthlyInstallment = 0;
	this.secondMonthlyInstallment = 0;
	this.amountToRepay = 0;
	this.currency = null;
	this.apr = 0;
	this.aprc = 0;
	this.aprc2 = 0;
	this.fee = 0;
	this.notaryCost = 0;
	this.paymentsHistoryFirstPeriod = []; //full list of montly installments 
	this.paymentsHistoryWholePeriod = []; //full list of montly installments 
	this.p = []; // full loan plan 
	this.urlParams = {};
	this.isWithMortgage = $('[data-algorithm-input="mortgage"]').length > 0; 
	
	this.min_approval_cost = 0;
	this.max_approval_cost = 0;
	this.approval_cost = 0;
	this.maxAmountForVariant = 0;
	this.tenor = 0;
	this.defaultValue = true;
	this.standard = true;
    this.stepTenor = [];
    this.customer = true;
    this.clientSegment = "";
	
	/**
	 * Init component
	 *
	 */
	this.init = function() {

		// get settings and labels
		loan.getSettingsAndLabelsJsonData();

		// check if calculator exixts
		var typeLoan = $("#typeloan").val();
		var bank = $('html').attr('data-bank');
		var isBIBCombined = bank == 'BIB';
		if(typeLoan != "combined"){
			isBIBCombined = false;
		}
		var isBANK = isBIBCombined;
		
		if( !$( "section.com16-14" ).length || !isBANK || invalidJsonFiles ) return;
		if(typeLoan == "combined"){
			console.log("combined loan");
			// handle education special case
			// loan.handleEducationCalculators();
	
			// init methods
			
			loan.setVisibleCalculatorAsActive();
		    var calculatorNavigation = Intesa.CalculatorNavigation.getInstance(loan.activeCalculator);
		    calculatorNavigation.init();
			loan.setActiveVariant();
			loan.setActiveMortgage( loan.getDefaultMortgage() );
			loan.setActiveCurrency( loan.getDefaultCurrency() );
			loan.setTabInitValue();
			loan.setActiveInterestType( loan.getDefaultInterestType() );
			loan.clientSegment = $(".massBtn", loan.activeCalculator).parent().text().trim();
			loan.mapSliders();
	
			// update calculator
			loan.initCalculatorInputs();
			loan.updateCalculatorOutputs();
	
			// attach on change events
			loan.attachChangeEvents();
	
			// trigger click on default education
			loan.triggerDefaultEducation();
	
			// get URL query params
			loan.getUrlQueryStringParams();		
	
			// fill inputs with query params
			loan.fillInputsWithQueryParams();
		}

	};

	/**
	 * Set Tab Init Value
	 *
	 */
	this.setTabInitValue = function() {
		
		if (loan.urlParams && loan.urlParams.isDefault){
		
			var activeTab = loan.urlParams.isDefault === 'false' ? false : true;
			
			loan.setActiveTab( activeTab, true , undefined);
			loan.defaultValue = activeTab;
		} else {
			
			var c; 
			// cerca la variante di default
			// cerca la currency di default 
			// cerca il glConfigurationList di default
			
			var variantList = loan.activeVariant.glProductVariantList;
			
			var isWithoutSalaryTransfer = -1; 
			
			var calcConfig; 
			
			for (i = 0 ; (i < variantList.length && isWithoutSalaryTransfer === -1); i++){
				
				if (variantList[i]['default'] === true){
					
					var currencyList = variantList[i].glConfigurationList;
					
					for (j = 0 ; j < (currencyList.length && isWithoutSalaryTransfer === -1) ; j++){
					
						if (currencyList[j]['default'] === true){
							
							var configList = currencyList[j].glGenericCalculationList;
							
							for (k = 0 ; (k < configList.length && isWithoutSalaryTransfer === -1) ; k++){
								
								if (configList[k]['default'] === true){
									
									isWithoutSalaryTransfer = configList[k]['isDefault'];
									
									calcConfig = configList[k];
									
									break;
									
								}	
								
							}
							
						}
						
						
					}
					
				}
				
			}
			
			if (calcConfig && calcConfig.standard){

				loan.setActiveTab( false , true , calcConfig);
				loan.defaultValue = false;
			}
			else {
				
				loan.setActiveTab( true , true , calcConfig);
				loan.defaultValue = true;
			}
			
			
		}

	};
	
    this.calculateStepIntermezzo = function() {
        var minCur = loan.activeTab.data.amountList[0].minimumTenor;
        var listSteps = [minCur];
        var indexesStep = [0];
        var tenorscaling = loan.activeTab.data.amountList[0].tenorScalingFactor;
        var maxCur = loan.activeTab.data.amountList[0].maximumTenor;
        var currentValue = minCur;
        var count = 0;
        for (var i = 0; currentValue < maxCur; i++) {
        	
        	currentValue = currentValue + tenorscaling;
        	if(currentValue >= maxCur){
        		currentValue = maxCur;
        	}
            count++;
            listSteps.push(currentValue);
        }
        if (loan.activeInterestType.periods === 2) {
            minCur = loan.activeTab.data.amountList[1].minimumTenor;
            maxCur = loan.activeTab.data.amountList[1].maximumTenor;
            tenorscaling = loan.activeTab.data.amountList[1].tenorScalingFactor;
            currentValue = minCur;
			listSteps.push(currentValue);
            for (var i = 0; currentValue < maxCur; i++) {
            	
            	currentValue = currentValue + tenorscaling;
            	if(currentValue >= maxCur){
            		currentValue = maxCur;
            	}
                count++;
                listSteps.push(currentValue);
            }
        }
        if (loan.activeInterestType.periods === 3) {
            minCur = loan.activeTab.data.amountList[1].minimumTenor;
            maxCur = loan.activeTab.data.amountList[1].maximumTenor;
            tenorscaling = loan.activeTab.data.amountList[1].tenorScalingFactor;
            currentValue = minCur;
			listSteps.push(currentValue);
            for (var i = 0; currentValue < maxCur; i++) {
            	
            	currentValue = currentValue + tenorscaling;
            	if(currentValue >= maxCur){
            		currentValue = maxCur;
            	}
                count++;
                listSteps.push(currentValue);
            }
            minCur = loan.activeTab.data.amountList[2].minimumTenor;
            maxCur = loan.activeTab.data.amountList[2].maximumTenor;
            tenorscaling = loan.activeTab.data.amountList[2].tenorScalingFactor;
            currentValue = minCur;
			listSteps.push(currentValue);
            for (var i = 0; currentValue < maxCur; i++) {
            	
            	currentValue = currentValue + tenorscaling;
            	if(currentValue >= maxCur){
            		currentValue = maxCur;
            	}
                count++;
                listSteps.push(currentValue);
            }
        }
        loan.stepTenor = listSteps;
    }
	
	/**
	 * Get Url Query String Params
	 *
	 */
	this.getUrlQueryStringParams = function() {

		// get url
		var currentURL = window.location.href;
			currentURL = currentURL.split('?');

		// get query params
		var queryString = currentURL[1];

		// check query string not empty
		if( queryString !== undefined ) {

			var params = queryString.split('&');

			params.forEach( function( param ) {

				var property = param.split('=');
				var propertyName = property[0];
				var propertyValue = property[1];

				// set loan.urlParams property
				loan.urlParams[propertyName] = propertyValue;

			} );

		}

	};	

	/**
	 * Fill Inputs With Query Params
	 *
	 */
	this.fillInputsWithQueryParams = function() {

		var thereAreQueryParams = $.isEmptyObject(loan.urlParams) ? false : true;

		if( thereAreQueryParams ) {

			//set the loan purpose
		//	loan.setLoanPurposeFromQuery();			

			// set interest rate
			loan.setInterestRateFromQuery();

			//set mortgage
			loan.setMortgageFromQuery();

			// set loan amount
			loan.setLoanAmountFromQuery();

			// set currency
			loan.setCurrencyFromQuery();				

			// set tenor
			loan.setTenorFromQuery();		

		}

	};	

	/**
	 * Set Currency From Query
	 *
	 */
	this.setCurrencyFromQuery = function() {

		var currencyUrl = loan.urlParams.currency;
		var currencyUrlSelect = $( '[data-algorithm-input="currency"]' , loan.activeCalculator);

		if ( currencyUrl && currencyUrlSelect.length ) {

			currencyUrlSelect.val(currencyUrl).trigger("change");

		}

	};	

	/**
	 * Set Loan purpose From Query
	 *
	 */
	this.setLoanPurposeFromQuery = function() {

		// var loanpurpose = loan.urlParams.loanpurpose;
		// var loanpurposeElement = $( '[data-filter="'+loanpurpose+'"]' );

		// if ( loanpurpose && loanpurposeElement.length ) {

		// 	loanpurposeElement.trigger("click");
		// 	loan['loanpurpose'] = loanpurpose;

		// 	loan['sliderNumnber'] = $('[data-filter]').index(loanpurposeElement);

		// }

	};		
	

	/**
	 * Set Loan Amount From Query
	 *
	 */
	this.setLoanAmountFromQuery = function() {

		var loanAmount = loan.urlParams.loanAmount;
		// var loanpurpose = loan.urlParams.loanpurpose;
		// var loanpurposeElement = $( '[data-filter="'+loanpurpose+'"]' );		

		if ( loanAmount && !isNaN( loanAmount ) ) {

			loanAmount = parseInt( loanAmount );
			var loanAmountInput = $( '[data-algorithm-input="loanAmount"]', loan.activeCalculator );

			// if ( loanpurpose && loanpurposeElement.length ) {
			// 	loanAmountInput = $( '[data-algorithm-input="loanAmount"]',loanpurposeElement );
			// }			

			loanAmountInput.val( loanAmount );
			loan.formatMoneyInputs();

		}

	};


	/**
	 * Set Interest Rate From Query
	 *
	 */
	this.setInterestRateFromQuery = function() {

		var interestRateType = loan.urlParams.interestRateType;
		var interestRateTypeSelect = $( '[name="interestRateType"]', loan.activeCalculator );

		if ( interestRateType && interestRateTypeSelect.length ) {

			interestRateTypeSelect.val(interestRateType).trigger("change");

		}

	};

	/**
	 * Set Mortgage From Query
	 *
	 */
	this.setMortgageFromQuery = function() {

		var mortgage = loan.urlParams.mortgage;
		var mortgageContainer = $( '[data-algorithm-input="mortgage"]' , loan.activeCalculator);

		if ( mortgage && mortgageContainer.length ) {

			$("[name=radio][value="+mortgage+"]",mortgageContainer).trigger("click");

		}

	};	
	
	
	/**
	 * Set Tenor From Query
	 *
	 */
	this.setTenorFromQuery = function() {

		var tenor = parseInt( loan.urlParams.tenor );
		// var loanpurpose = loan.urlParams.loanpurpose;
		// var curSlider = $( 'div[data-filter="'+loanpurpose+'"] .rangeslider' );

		if ( tenor && !isNaN(tenor) ) {

			// get step value
			var step = $( '[data-slider-repayment]', loan.activeCalculator ).attr( 'data-slider-step' );
				step = parseInt( step );

			// round tenor based on step
			tenor =  tenor - ( tenor % step );
			
			//convert in years
			if( loan.tenorUnit === 'YEARS' ) {
				tenor = tenor / 12;
			}		

			// set tenor
			// if((curSlider!==undefined)&&(loanpurpose!==undefined)){

			// 	curSlider.slider( 'setValue', tenor, true );

			// } else{

				window.sliderbootstrap[0].slider( 'setValue', tenor, true );

		//	}

		}

	};
	
	
	this.calcAprc = function (paymentsList, loanAmount) {
		  return loan.calcAprcWithBinarySearch(paymentsList, loanAmount, 0.0, 1.0, 0);
	}
	
	/*
	 * minValue = minimum possible aprc
	 * maxValue = maximum possible aprc
	*/
	this.calcAprcWithBinarySearch = function (payments, s, minValue, maxValue, iterationLvl) {
	  // check if the interval is zero or less than certain decimal places
	  if ((maxValue - minValue) < 0.00000000000001) { // rounded to the fourth decimal place
	    return minValue;
	  }

	  // guessing APRC with binary search
	  const aprc = (maxValue - minValue) / 2 + minValue;

	  // check if we have maximized the iterations
	  if (iterationLvl > loan.MAX_ITERATIONS) {
	    return aprc;
	  }

	  const leftSideOfTheEquation = s;
	  var rightSideOfTheEquation = 0.0;
	  for (var i = 0; i < payments.length; i++) {
	    const Ak = payments[i];
	    rightSideOfTheEquation += Ak * Math.pow(1+ aprc, -(i+1.0) / 12.0);
	  }

	  // check if the aprc is correct guessed
	  if (leftSideOfTheEquation == rightSideOfTheEquation) {
	    return aprc;
	  } else if (leftSideOfTheEquation < rightSideOfTheEquation) {
	    return loan.calcAprcWithBinarySearch(payments, s, aprc, maxValue, ++iterationLvl);
	  } else { // leftSideOfTheEquation > rightSideOfTheEquation
	    return loan.calcAprcWithBinarySearch(payments, s, minValue, aprc, ++iterationLvl);
	  }
	}


	/**
	 * Get Settings And Labels Json Data
	 *
	 */
	this.getSettingsAndLabelsJsonData = function() {

		var settings = $( "#genericSettings" );
		var labels = $( "#calculatorLabels" );

		try {

			// get generic settings
			if( settings.length ) {
				genericSettings = JSON.parse( settings.val() );
			}

			// get calculator labels
			if( labels.length ) {
				calculatorLabels =  JSON.parse( labels.val() );
			}

		} catch(e) {

			console.error( 'Settings or Labels JSON file invalid' );
			invalidJsonFiles = true;

		}

	};

    this.findIndexByTenor = function(tenor) { return loan.stepTenor.indexOf(tenor); }
    this.findTenorByIndex = function(index) { return loan.stepTenor[index]; }
	/**
	 * Update Calculator Inputs
	 *
	 */
	this.initCalculatorInputs = function() {
		
		loan.updateInterestTypeSelect();
		loan.updatePeriodLines();
		loan.updateLoanAmountInput();
		loan.updateCurrencySelect();
		loan.updateTenorUnit();
		loan.startTenorSlider();
		loan.updateTenorSelect();
		loan.updateMortgageRadio();
		loan.updateFee();
		loan.updateNotaryCost();
		loan.formatMoneyInputs();

	};
	
	/**
	 * Update Calculator Inputs
	 *
	 */
	this.updateCalculatorInputs = function() {
		
		loan.updateInterestTypeSelect();
		loan.updatePeriodLines();
		// loan.updateLoanAmountInput();
		loan.updateCurrencySelect();
		loan.updateTenorUnit();
		// loan.updateTenorSlider();
		loan.updateMortgageRadio();
		loan.updateFee();
		loan.updateNotaryCost();
		loan.formatMoneyInputs();

	};


	/**
	 * Update Calculator Outputs
	 *
	 */
	this.updateCalculatorOutputs = function() {
		loan.getCalculatorInputs();
		loan.getTenorInMonths();
		loan.getInterestRates();
		loan.calculateMonthlyInstallments();
		loan.calculateAmountToRepay();
		loan.getPaymentListByPlan();
		loan.updateFee();
		var initialExpenses = loan.getInitialExpenses(loan.loanAmount , loan.fee , loan.notaryCost , loan.isWithMortgage);
		loan.calculateAPRC(initialExpenses  ,0);
		// loan.calculateAPRC2(initialExpenses ,0);
		loan.checkErrors();
		loan.appendCalculatorOutputs();
		if( development ) loan.consoleLogValues();

		//toggle show status
		$("[data-showStatus]", loan.activeCalculator).hide();

		//show higher aprc
		// var is2PeriodLoan =  ((loan.activeInterestType.periods === 2) && (loan.activeInterestType.secondPeriod !== undefined) && ( loan.tenor > loan.activeInterestType.firstPeriod.monthDuration ));
		/* if (loan.activeInterestType.periods  === 2) {
			var isVariableInsterestSmaller =loan.activeInterestType.secondPeriod.interestRate < loan.activeInterestType.firstPeriod.interestRate;
			if (isVariableInsterestSmaller){
				$('[data-aprc="first"]').show();
				$('[data-aprc="second"]').hide();
			} else {
				$('[data-aprc="first"]').hide();
				$('[data-aprc="second"]').show();			
			} 
		}
 		else {
			$('[data-aprc="first"]').show();
			$('[data-aprc="second"]').hide();
		}
		*/
		
		if (loan.isWithMortgage){
			$('[data-aprc="notary_cost"]', loan.activeCalculator).show();
		} else {
			$('[data-aprc="notary_cost"]', loan.activeCalculator).hide();		
		} 
		
		$('[data-aprc="first"]', loan.activeCalculator).show();
		$('[data-aprc="second"]', loan.activeCalculator).hide();
			
		// update share calculator
		loan.updateShareCalculatorLink();

		// update input hidden
		loan.updateContactInputHidden();

	};


    /**	 
     * Update Contact Input Hidden
     *
     */
    this.updateContactInputHidden = function() {

        /*
            TODO: move this data inside a input hidden and remove #test div.
        */
        var data = JSON.stringify({
            LOANAMOUNT: number_format(parseFloat(loan.loanAmount), 2, genericSettings.decimal, genericSettings.separator),
            DURATION: loan.tenor,
            INSTALLMENT: number_format(parseFloat(loan.firstMonthlyInstallment), 2, genericSettings.decimal, genericSettings.separator),
            DISCOUNTCODE: null,
            APR: number_format(parseFloat(loan.aprc), 2, genericSettings.decimal, genericSettings.separator),
            INTERESTRATE: number_format(parseFloat(loan.firstInterestRate), 2, genericSettings.decimal, genericSettings.separator)
        });
        var lang_calculator = $('input[name=loanCalculatorLanguage]').val();
        if (lang_calculator == 'sr' ){
        	data = JSON.stringify({
        		IZNOSKREDITA: number_format(parseFloat(loan.loanAmount), 2, genericSettings.decimal, genericSettings.separator),
        		TRAJANJE: loan.tenor,
        		RATA: number_format(parseFloat(loan.firstMonthlyInstallment), 2, genericSettings.decimal, genericSettings.separator),
        		KODZAPOPUST: null,
                APR: number_format(parseFloat(loan.aprc), 2, genericSettings.decimal, genericSettings.separator),
                KAMATNASTOPA: number_format(parseFloat(loan.firstInterestRate), 2, genericSettings.decimal, genericSettings.separator)
            });
        }

        $('[data-cmb-input]').attr('value', data);
        $('#getloan-calc-config').attr('value', data);

    };

    this.getNextVal = function(){
	    var $slider = $('.rangeslider', loan.activeCalculator);
	    var $wrapper = $('.rangeslider', loan.activeCalculator).parents('.sliderRange__wrapper');
	    var $stepData = $slider.attr('data-slider-step');
	    var $step = parseInt($stepData);
	    var $minData = $slider.attr('data-slider-min');
	    var $min = parseInt($minData);
	    var $maxData = $slider.attr('data-slider-max');
	    var $max = parseInt($maxData);
	    var $qty = $wrapper.find('.qty');
	    var $valShow = $wrapper.find('.valShow');
	    var currentVal = parseInt($qty.val());
	    // console.log($step)

	    if (!isNaN(currentVal) && currentVal < $max) {
	      if((currentVal + $step) > $max ) {
	        return $max;
	      } else {
	        var newValue = currentVal + $step;
	        return newValue;
	      }
	    } else {
	    	return $max;
	    }
    };
    
    this.getPrevVal = function(){
	    var $slider = $('.rangeslider', loan.activeCalculator);
	    var $wrapper = $('.rangeslider', loan.activeCalculator).parents('.sliderRange__wrapper');
	    var $stepData = $slider.attr('data-slider-step');
	    var $step = parseInt($stepData);
	    var $minData = $slider.attr('data-slider-min');
	    var $min = parseInt($minData);
	    var $maxData = $slider.attr('data-slider-max');
	    var $max = parseInt($maxData);
	    var $qty = $wrapper.find('.qty');
	    var $valShow = $wrapper.find('.valShow');
	    var currentVal = parseInt($qty.val());

	    if (!isNaN(currentVal) && currentVal > $min) {
	      if((currentVal - $step) < $min ) {
	        return $min;
	      } else {
	        var newValue = currentVal - $step;
	        return newValue;
	      }
	    } else {
	    	return $min;
	    }
    };
    this.plusBut = function(){
	    var $slider = $('.rangeslider', loan.activeCalculator);
	    var $wrapper = $('.rangeslider', loan.activeCalculator).parents('.sliderRange__wrapper');
	    var $stepData = $slider.attr('data-slider-step');
	    var $step = parseInt($stepData);
	    var $minData = $slider.attr('data-slider-min');
	    var $min = parseInt($minData);
	    var $maxData = $slider.attr('data-slider-max');
	    var $max = parseInt($maxData);
	    var $qty = $wrapper.find('.qty');
	    var $valShow = $wrapper.find('.valShow');
	    var currentVal = parseInt($qty.val());
	    // console.log($step)

	    if (!isNaN(currentVal) && currentVal < $max) {
	      if((currentVal + $step) > $max ) {
	        $qty.val($max);
	        $valShow.text(Number($max));
	        $slider.slider('setValue', $max);
	      } else {
	        var newValue = currentVal + $step;
			var counts = [6, 12, 18, 24, 36, 48, 60, 71];
			goal = newValue;
			newValue = counts.reduce(function(prev, curr) {
				  return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
				});
	        $qty.val(newValue);
	        // console.log(this.applyFormatter);
	        $valShow.text(Number(newValue));
	        $slider.slider('setValue', newValue);
	      }
	    }
	  };

	  this.minusBut = function(){
	    var $slider = $('.rangeslider', loan.activeCalculator);
	    var $wrapper = $('.rangeslider', loan.activeCalculator).parents('.sliderRange__wrapper');
	    var $stepData = $slider.attr('data-slider-step');
	    var $step = parseInt($stepData);
	    var $minData = $slider.attr('data-slider-min');
	    var $min = parseInt($minData);
	    var $maxData = $slider.attr('data-slider-max');
	    var $max = parseInt($maxData);
	    var $qty = $wrapper.find('.qty');
	    var $valShow = $wrapper.find('.valShow');
	    var currentVal = parseInt($qty.val());
	    
	    if (!isNaN(currentVal) && currentVal > $min) {
	      if((currentVal - $step) < $min ) {
	        $qty.val($min);
	        $valShow.text(Number($min));
	        $slider.slider('setValue', $min);
	      } else {
	        var newValue = currentVal - $step;
			var counts = [6, 12, 18, 24, 36, 48, 60, 71];
			goal = newValue;
			newValue = counts.reduce(function(prev, curr) {
				  return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
				});
	        $qty.val(newValue);
	        $valShow.text(Number(newValue));
	        $slider.slider('setValue', newValue);
	      }
	    }
	  };
	
	/**
	 * Attach Change Events
	 *
	 */
	this.attachChangeEvents = function() {
		
		//disabilito react
		$('.js-btnMinus, .js-btnAdd', loan.activeCalculator).unbind("click");
		$(".rangeslider--2", loan.activeCalculator).unbind("slide");
		$(".rangeslider--2", loan.activeCalculator).unbind("change");	
		// on calculator change
		$( document ).on( 'click', '.com15__filterItem', function() {
			var id = $( this ).attr( 'data-filter' );
			var width = $(window).width();
			var calculatorResolution = "desktop" ;
			if(width < 768){
				var calculatorResolution = "mobile" ;
			}
			var calculator = $( '.com15__filter[data-filter="' + id + '"]' ).find( '[data-calculator='+calculatorResolution+']');

		//	loan['loanpurpose'] = id;
			loan.setActiveCalculator( calculator );
			loan.setActiveVariant();
			loan.setActiveMortgage( loan.getDefaultMortgage() );
			loan.setActiveCurrency( loan.getDefaultCurrency() );
			loan.setActiveInterestType( loan.getDefaultInterestType() );
			loan.updateCalculatorInputs();
			loan.updateCalculatorOutputs();
		} );
		
		
		$(document).on('change', '[data-tenor-select]', function () {
            var slider = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            var index = parseInt(slider.attr('data-slider-index'));
                
            if(loan.activeVariant.productId == '10021' ||
                    loan.activeVariant.productId == '10022' ||
                    loan.activeVariant.productId == '10023' ||
                    loan.activeVariant.productId == '30041' ||
                    loan.activeVariant.productId == '30042' ||
                    loan.activeVariant.productId == '30043' ||
                    loan.activeVariant.productId == '20031' ||
                    loan.activeVariant.productId == '20032' ||
                    loan.activeVariant.productId == '20033' ||
                    loan.activeVariant.productId == '40051' ||
                    loan.activeVariant.productId == '40052' ||
                    loan.activeVariant.productId == '40053'){    
                    
		            var step  = loan.findIndexByTenor( parseInt($(this).val()) );
		
		            if( step != -1 ){
		                var wrapper = $(slider).parents('.sliderRange__wrapper');
	                    wrapper.find('.qty').val(step);
	                    wrapper.find('.valShow').html(step);
		                window.sliderbootstrap[index].slider('setValue', step, true);
		                wrapper.find( '.rangeslider' ).trigger('change');
		            }
            } else {
                    var value = $(this).val();
                    console.log("value è:" + value);
                    var wrapper = $(slider).parents('.sliderRange__wrapper');
                    wrapper.find('.qty').val(value);
                    wrapper.find('.valShow').html(value);
                    window.sliderbootstrap[index].slider('setValue', value, true);
                    wrapper.find( '.rangeslider' ).trigger('change');
            }
            loan.updateCalculatorOutputs();
            
		});
		
		// on change tab
		$( document ).on( 'click', '[data-tab-default]', function() {

			var defaultValue = $(this).attr('data-tab-default') === 'true';
			loan.defaultValue = defaultValue;
			loan.customer = defaultValue;
			loan.updateCalculatorConfigurationByTenor(loan.tenor, defaultValue);
			loan.updateTenorSelect();
			loan.setActiveTabByVal( defaultValue, false , loan.activeTab);
			loan.setActiveInterestType( loan.activeInterestType.interestCode );
			loan.updateCalculatorInputs();
			loan.updateCalculatorOutputs();

		});


		// on change mortgage radio buttons
		$( document ).on( 'change', '[data-algorithm-input="mortgage"] input', function() {
			var value = $( this ).val();
			loan.isWithMortgage = (value == 'WITH_MORTGAGE'); 
			loan.setActiveMortgage( value );
			loan.setActiveCurrency( loan.activeCurrency.currency );
			loan.setActiveInterestType( loan.activeInterestType.interestCode );
			$("[data-tab-default]").trigger("click");
			loan.updateCalculatorInputs();
			loan.updateCalculatorOutputs();
		});


		// on change currency select
		$( document ).on( 'change', '[data-algorithm-input="currency"]', function() {
			var value = $( this ).val();
			loan.setActiveCurrency( value );
			loan.setActiveInterestType( loan.activeInterestType.interestCode );
			loan.updateCalculatorInputs();
			loan.updateCalculatorOutputs();
		});


		// on change interest select
		$( document ).on( 'change', '[data-interest-select]', function() {
			var value = $(this).val();
			loan.setActiveMortgage(value);
			loan.setActiveCurrency(loan.activeCurrency.currency);
			loan.updateCalculatorConfigurationByTenor(loan.tenor, loan.defaultValue);
			loan.setActiveInterestType( value );
			loan.updateTenorSelect();
			loan.updateCalculatorInputs();
			loan.updateCalculatorOutputs();
		});
		
		$(document).on('change', "[data-algorithm-input=newInterest] input", function(){
			var value = $( this ).val();
			$("select[data-interest-select]", loan.activeCalculator).val(value);
			$("select[data-interest-select]", loan.activeCalculator).trigger('change');
		});

		$( document ).on( 'change focusout keyup', '[data-algorithm-input]', function() {
			loan.updateCalculatorOutputs();
		});
		// on change inputs
		$( document ).on( 'change focusout keyup', '[data-algorithm-input="loanAmount"]', function() {
			loan.updateCalculatorConfigurationByTenor(loan.tenor, loan.defaultValue);
			loan.updateTenorSelect();
			loan.updateCalculatorOutputs();
		});

		// on click slider buttons
		$( document ).on( "click", '.js-btnMinus, .js-btnAdd', function(event) {
			var value = $('.rangeslider').val();
			if($(this).hasClass("js-btnAdd")){
				value = loan.getNextVal();
			}
			if($(this).hasClass("js-btnMinus")){
				value = loan.getPrevVal();
			}
            if($(this).hasClass("js-btnMinus")){
            	loan.minusBut();
            }
            loan.updateCalculatorConfigurationByTenor(value, loan.defaultValue);
            if($(this).hasClass("js-btnAdd")){
            	loan.plusBut();
            }
            var wrapper = $('.rangeslider').parents('.sliderRange__wrapper');
//            wrapper.find('.qty').val(value);
            wrapper.find( '.qty' ).trigger('change');

		} );


		// enable change slider on click
		$( document ).on( "change", '.rangeslider', function(event) {
			var value = $( this ).val();
			var counts = [6, 12, 18, 24, 36, 48, 60, 71];
			goal = value;

			value = counts.reduce(function(prev, curr) {
			  return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
			});
			loan.updateCalculatorConfigurationByTenor(value, loan.defaultValue);

			var wrapper = $( this ).parents( '.sliderRange__wrapper' );			
			wrapper.find( '.qty' ).val( value );
			$( this ).slider('setValue', value, true);
			$( this ).val(value);
			wrapper.find('.valShow').html(value);
			loan.updateCalculatorOutputs();
			// 
			// change variant 
			// 
			
			
		} );
		
        $(document).on('click', '.massBtn', function() {
            if (!$(".massBtn", loan.activeCalculator).hasClass("clicked")) {
                $(".upperMassBtn", loan.activeCalculator).removeClass("clicked");
                $(".massBtn", loan.activeCalculator).addClass("clicked");
                var isClient = $("[data-tab-default=true]", loan.activeCalculator).prop("checked") == true;
                loan.clientSegment = $(this).parent().text().trim();
                loan.setActiveVariant();
                loan.setTabInitValue();
                loan.setActiveMortgage(loan.activeMortgage.variantType);
                loan.setActiveCurrency(loan.currency);
                loan.setActiveInterestType(loan.activeInterestType.interestCode);
                $(".rangeslider--2", loan.activeCalculator).trigger("change");
                if(!isClient){
                	$("[data-tab-default=false]", loan.activeCalculator).trigger("click");
                }
                
                loan.updateCalculatorOutputs();
            }
        });

        $(document).on('click', '.upperMassBtn', function() {
            if (!$(".upperMassBtn", loan.activeCalculator).hasClass("clicked")) {
                $(".massBtn", loan.activeCalculator).removeClass("clicked");
                $(".upperMassBtn", loan.activeCalculator).addClass("clicked");
                var isClient = $("[data-tab-default=true]", loan.activeCalculator).prop("checked") == true;
                loan.clientSegment = $(this).parent().text().trim();
                loan.setActiveVariantUpperMass();
                loan.setTabInitValue();
                loan.setActiveMortgage(loan.activeMortgage.variantType);
                loan.setActiveCurrency(loan.currency);
                loan.setActiveInterestType(loan.activeInterestType.interestCode);
                $(".rangeslider--2", loan.activeCalculator).trigger("change");
                if(!isClient){
                	$("[data-tab-default=false]", loan.activeCalculator).trigger("click");
                }

                loan.updateCalculatorOutputs();
            }
        });

	};


    this.updateTenorSelect = function() {
        var select = $('[data-tenor-select]', loan.activeCalculator);

        if(select) {
        	select.html('');
//            loan.calculateStepIntermezzo();
        	loan.stepTenor = [6, 12, 18, 24, 36, 48, 60, 71];
        	if(loan.activeMortgage.variantType == "VARIABLE"){
        		loan.stepTenor = [71];
        	}
            loan.stepTenor.forEach(function(i) {
                var option = $("<option value=" + i + ">" + i + "</option>");
                if(i == $( '.rangeslider.rangeslider--2', loan.activeCalculator ).attr("data-value")){
                	option = $("<option value=" + i + " selected>" + i + "</option>");
                }
                select.append(option);
            });


            var tenorMin = loan.findTenorByIndex(0);
            var tenorMax = loan.findTenorByIndex(loan.stepTenor.length - 1);
            
            var wrapper = select.parents('.loanDuration__wrp');

            wrapper.find('[data-min-tenor]').html(tenorMin);
            wrapper.find('[data-max-tenor]').html(tenorMax);
        
        }
    }
	
	
	/**
	 * Trigger Default Education
	 *
	 */
	this.triggerDefaultEducation = function() {

		if( loan.defaultEducation !== null ) {

			$( '[data-filter="' + loan.defaultEducation + '"]' ).trigger( 'click' );

		}

	};


	/**
	 * Handle Education Calculators
	 *
	 */
	this.handleEducationCalculators = function() {

		var educationCalculators = $( '[data-education]' );

		if( educationCalculators.length ) {

			educationCalculators.each( function() {

				var calculator = $(this);
				var calculatorData = loan.getEducationCalculatorDataFromJSON( calculator );
				var variantName = calculator.attr( 'data-filter' );

				if( calculatorData !== null ) {

					// remove other variants from JSON
					calculatorData = loan.removeEducationVariantsFromJSON( calculatorData, variantName );

					// set default education
					var isDefault = calculatorData.glGenericSimulatorParams.glProductVariantList[0].default;
					if( isDefault ) loan.defaultEducation = variantName;

					// insert new JSON
					calculatorData = JSON.stringify( calculatorData );
					calculator.find( '.calculatorData' ).val( calculatorData );

				}

			} );

		}

	};


	/**
	 * Remove Education Variants From JSON
	 *
	 */
	this.removeEducationVariantsFromJSON = function( calculatorData, variantName ) {

		calculatorData.glGenericSimulatorParams.glProductVariantList.forEach( function( item, index, array ) {

			// remove variant if different from variant name
			if( item.variantType !== variantName ) {

				array.splice(index, 1);

			}

		} );

		return calculatorData;

	};


	/**
	 * Get Education Calculator Data From JSON
	 *
	 */
	this.getEducationCalculatorDataFromJSON = function( calculator ) {

		var data = null;
		var calculatorData = calculator.find( '.calculatorData' ).val();

		try {

			data = JSON.parse( calculatorData );

		} catch(e) {

			console.error( 'Education JSON file invalid' );

		}

		return data;

	};


	/**
	 * Check Errors
	 *
	 */
	this.checkErrors = function() {

		// get parsley errors
		var errors = $( '.parsley-errors-list li', loan.activeCalculator ).length;

		if( errors > 0 ) {

			loan.errorState = true;

		} else {

			loan.errorState = false;

		}

	};


	/**
	 * Map Sliders
	 *
	 */
	this.mapSliders = function() {

		var sliders = window.sliderbootstrap;

		// map every slider with its instance inside sliderbootstrap window property
		sliders.forEach( function( item, index ) {

			item.attr( 'data-slider-index', index );

		} );

	};


	/**
	 * Set Active Calculator
	 *
	 */
	this.setActiveCalculator = function( calculator ) {

		loan.activeCalculator = calculator;

	};


	/**
	 * Set Visible Calculator As Active
	 *
	 */
	this.setVisibleCalculatorAsActive = function() {

		var width = $(window).width();
		var calculatorResolution = "desktop" ;
		if(width < 768){
			var calculatorResolution = "mobile" ;
		}
		var calculators = $( '[data-calculator='+calculatorResolution+']' );
		var calculatorFound = false;

		calculators.each( function() {

			// set visible calculator as active
			if( $(this).is(":visible") ) {

				loan.activeCalculator = $( this );
				calculatorFound = true;

			}

		} );

		// handle no calculator active by default
		if( !calculatorFound ) loan.activeCalculator = $( '[data-calculator='+calculatorResolution+']'  ).first();

	};


	/**
	 * Get Tenor In Months
	 *
	 */
	this.getTenorInMonths = function() {

		if( loan.tenorUnit === 'YEARS' ) loan.tenor = loan.tenor * 12;

	};


	/**
	 * Update Fee
	 *
	 */
	this.updateFee = function() {

		//loan.fee = loan.activeCurrency.glGenericCalculationList[0].fee;
		loan.fee = loan.activeTab.data.fee;
        loan.min_approval_cost = loan.activeTab.data.min_approval_cost;
        loan.max_approval_cost = loan.activeTab.data.max_approval_cost;
	};
	
	/**
	 * Update Fee
	 *
	 */
	this.updateNotaryCost = function() {

		loan.notaryCost = loan.activeTab.data.notary_costs;

	};


	/**
	 * Update Tenor Unit
	 *
	 */
	this.updateTenorUnit = function() {

		// get tenor unit
		loan.tenorUnit = loan.activeCurrency.tenorUnit;

		// get label
		var tenorUnitLabel = calculatorLabels[loan.tenorUnit];

		// insert label
		$( '[data-tenor-unit]', loan.activeCalculator ).text( tenorUnitLabel );

	};


	/**
	 * Get Interest Rates
	 *
	 */
	this.getInterestRates = function() {

		loan.setFirstInterestRate();
		loan.setSecondInterestRate();

	};


	/**
	 * Set First Interest Rate
	 *
	 */
	this.setFirstInterestRate = function() {

		// handle multiple interest rate for 1 period. If tenor > firstPeriodDuration set second period interest rate as first.
		if( loan.activeInterestType.periods === 1) {

			// loan.firstInterestRate = loan.activeInterestType.secondPeriod.interestRate;
			loan.updateCalculatorConfigurationByTenor(loan.tenor, loan.defaultValue);
			loan.updateTenorSelect();
			//loan.setActiveCurrency( loan.activeCurrency.currency );
			//loan.setActiveTab(loan.activeTab.isDefault, false);
			loan.setActiveInterestType(loan.activeInterestType.interestCode );
			loan.firstInterestRate = loan.activeInterestType.firstPeriod.interestRate;

		} else {
			
			loan.firstInterestRate = loan.activeInterestType.firstPeriod.interestRate;
			

		}

	};


	/**
	 * Set Second Interest Rate
	 *
	 */
	this.setSecondInterestRate = function() {

		// if second period exists set it
		if( loan.activeInterestType.periods === 2 && loan.activeInterestType.secondPeriod !== undefined ) {

			loan.secondInterestRate = loan.activeInterestType.secondPeriod.interestRate;

		} else {

			loan.secondInterestRate = '-';

		}

	};


	/**
	 * Calculate Monthly Installments
	 *
	 */
	this.calculateMonthlyInstallments = function() {

		var loanAmount = loan.loanAmount;		
		var loanDurationInYear = loan.tenor/12;		

		// full loan payment plan
		var paymentList = []; 
		
		// calculate first period payment plan 
		var p1 = loan.piano(loanAmount , loanDurationInYear , loan.firstInterestRate , 12);
		
		// second period plan  
		var p2 = [];

		// full loan plan
		loan.p = [];

		var p1FirstPayment 	= [];
		var p1LastPayment 	= [];
		var p2FirstPayment 	= [];
		var p2LastPayment 	= [];
		
		// if there are multiple periods:
		var is2PeriodLoan = ((loan.activeInterestType.secondPeriod !== undefined) && ( loan.tenor > loan.activeInterestType.firstPeriod.monthDuration ));
		
		if(loan.activeInterestType.periods  === 2) {

			// get paymnent detail at the beginning and at the end of the first period 
			p1FirstPayment 	= p1[0];
			p1LastPayment 	= p1[loan.activeInterestType.firstPeriod.monthDuration-1];
			
			
			// get the first period montly installment 
			loan.firstMonthlyInstallment = parseFloat( loan.getRata(p1FirstPayment) );

			// fill the payment list with the montlyinstallments of the first period +1 
		    for (i = 0; ((i < p1.length) && (i < loan.activeInterestType.firstPeriod.monthDuration)); i++){
		    	loan.p.push(p1[i]);
		    }
			
			// get residual debit from first period 
			var debitoResiduo = loan.getDebitoRes(p1LastPayment);
			if (debitoResiduo >0){
				// calculate the second plan starting from the residual debit 
				// of the first period and using a different interest rate
				var ir2 = loan.activeInterestType.secondPeriod.interestRate;
				p2 = loan.piano(debitoResiduo , (loan.tenor-loan.activeInterestType.firstPeriod.monthDuration)/12 , ir2 , 12);

				// just need the montly installment so can get any index in p2
				p2FirstPayment = p2[0];
				
				loan.secondMonthlyInstallment  = parseFloat(loan.getRata(p2FirstPayment));				

			    for (i = 0; i < p2.length; i++){
			    	loan.p.push(p2[i]);
			    }
			}
		    // paymentList.length == loan.tenor

		} else {

			// Single Period loan 
			loan.secondMonthlyInstallment = '-';
			
			p1LastPayment 	= p1[p1.length-1];
			p1FirstPayment 	= p1[0];
			
			// get the first period montly installment 
			loan.firstMonthlyInstallment = parseFloat(loan.getRata(p1FirstPayment));

		    for (i = 0; i < p1.length; i++){
		    	loan.p.push(p1[i]);
		    }
		} 
	};

	/** 
	* Get the list of montlyInstallments for first and second 
	* Period 
	*/
	this.getPaymentListByPlan = function(){
		loan.paymentsHistoryFirstPeriod = []; 
		loan.paymentsHistoryWholePeriod = [];
		
		for (i = 0; i < loan.p.length ;  i++){
			loan.paymentsHistoryWholePeriod.push(loan.getRata(loan.p[i]));
		}

		for (i = 0; (i < loan.p.length && i < loan.activeInterestType.firstPeriod.monthDuration);  i++){
			loan.paymentsHistoryFirstPeriod.push(loan.getRata(loan.p[i]));
		}
	}

	
	/**
	 * Get the initial expenses of the loan 
	 */
	
	this.getInitialExpenses = function(loanAmount , approvalCostPercentage , notaryCost , isWithMortgage) {
		
		var approvalCost = (loanAmount * approvalCostPercentage) / 100;
		
		if (approvalCost <= loan.min_approval_cost){
			
			loan.approval_cost = loan.min_approval_cost;
			
		} else if (approvalCost >= loan.max_approval_cost){

			loan.approval_cost = loan.max_approval_cost;
			
		} else {

			loan.approval_cost = approvalCost;
			
		}
		
		initialExpenses = approvalCost;
		
        initialExpenses = approvalCost;
        notaryCost = 1; // non ci sono notary cost
        return initialExpenses;
	}

	/**
	 * Update Periods
	 *
	 */
	this.updatePeriodLines = function() {

		var periodsNumber = loan.activeInterestType.periods;
		var onePeriodElements = $( '[data-one-period]', loan.activeCalculator );
		var twoPeriodsElements = $( '[data-two-periods]', loan.activeCalculator );

		// if 2 periods show double monthlyInstallment/InterestRate
		if( periodsNumber === 2 ) {

			onePeriodElements.addClass( 'hide' );
			twoPeriodsElements.removeClass( 'hide' );

		} else {

			twoPeriodsElements.addClass( 'hide' );
			onePeriodElements.removeClass( 'hide' );

		}

	};


	/**
	 * Update Currency Select
	 *
	 */
	this.updateCurrencySelect = function() {

		var currencyOptions = loan.activeMortgage.glConfigurationList;
		var select = $( '[data-algorithm-input="currency"]', loan.activeCalculator );
		var html = '';
		var countCurrency = 0;
		if( select.length ) {

			// clear select
			select.html('');

			// generate select html
			currencyOptions.forEach( function( currency ) {

				currency = currency.currency;

				if( currency === loan.activeCurrency.currency ) {
					html += '<option value="' + currency + '" selected>' + currency + '</option>';
				} else {
					html += '<option value="' + currency + '">' + currency + '</option>';
				}
				countCurrency = countCurrency + 1;
			} );

			// append options
			select.append( html );
            if (countCurrency <= 1 && loan.typeLoan != 'carLoan') {
                $('[data-algorithm-input="currency"]', loan.activeCalculator).attr('disabled', true);
            }

		}

	};


	/**
	 * Update Mortgage Radio
	 *
	 */
	this.updateMortgageRadio = function() {

		var input = $( '[data-algorithm-input="mortgage"]', loan.activeCalculator );
		var activeMortgage = loan.activeMortgage.variantType;

		// trigger click on default mortgage
		if( input.length && activeMortgage !== null ) {

			$( 'input[value="' + activeMortgage + '"]' ).trigger( 'click' );

		}

	};
	



	/**
	 * Update Tenor Slider
	 *
	 */
	this.updateTenorSlider = function() {

		var input = $( '.rangeslider.rangeslider--2', loan.activeCalculator );

		if( input.length ) {

			var index = parseInt( input.attr( 'data-slider-index' ) );
			var slider = window.sliderbootstrap[index];
			var wrapper = input.parents('.sliderRange__wrapper');
			var sliderValue = input.attr('data-value');
			var counts = [6, 12, 18, 24, 36, 48, 60, 71];
			goal = sliderValue;

			sliderValue = counts.reduce(function(prev, curr) {
			  return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
			});
			
			// set step value
			var step = loan.activeTab.data.amountList[0].tenorScalingFactor;
			input.attr( 'data-slider-step', step );

			// set minimum
			var tenorMin = loan.activeInterestType.firstPeriod.monthMinimum ? loan.activeInterestType.firstPeriod.monthMinimum : loan.activeCurrency.glGenericCalculationList[0].amountList[0].minimumTenor;
			if (loan.activeInterestType.periods  === 2 && tenorMin <= loan.activeInterestType.firstPeriod.monthDuration){
				tenorMin = (loan.activeInterestType.firstPeriod.monthDuration + 12);
			}
			if( loan.tenorUnit === 'YEARS' ) tenorMin = tenorMin / 12;
			input.attr( 'data-slider-min', tenorMin );
			wrapper.find( '[data-min-tenor]' ).html( tenorMin );

			// set maximum
			var tenorMax = loan.activeInterestType.secondPeriod ? loan.activeInterestType.secondPeriod.monthDuration : loan.activeInterestType.firstPeriod.monthDuration;
			if( loan.tenorUnit === 'YEARS' ) tenorMax = tenorMax / 12;
			input.attr( 'data-slider-max', tenorMax );
			wrapper.find( '[data-max-tenor]' ).html( tenorMax );
			

			// rebuild slider
			slider.slider('destroy');
			slider.slider({ tooltip: 'show' });

			// set min as current value
			wrapper.find('.qty').val( sliderValue );
			wrapper.find('.valShow').html(sliderValue);
			slider.slider( 'setValue', sliderValue, true );
			loan.tenor = sliderValue;

			// attach slide event
//			slider.on( 'slide', function() {
//				var value = slider.slider('getValue');
//				wrapper.find('.qty').val(value);
//				input.siblings( '.qty' ).trigger('change');
//			} );

		}

	};
	
	
	this.startTenorSlider = function() {

		var input = $( '.rangeslider.rangeslider--2', loan.activeCalculator );

		if( input.length ) {

			var index = parseInt( input.attr( 'data-slider-index' ) );
			var slider = window.sliderbootstrap[index];
			var wrapper = input.parents('.sliderRange__wrapper');
			var sliderValue = loan.activeTab.data.defaultTenor;
			
			// set step value
			var step = loan.activeTab.data.amountList[0].tenorScalingFactor;
			input.attr( 'data-slider-step', step );

			// set minimum
			var tenorMin = loan.activeInterestType.firstPeriod.monthMinimum ? loan.activeInterestType.firstPeriod.monthMinimum : loan.activeCurrency.glGenericCalculationList[0].amountList[0].minimumTenor;
			if (loan.activeInterestType.periods  === 2 && tenorMin <= loan.activeInterestType.firstPeriod.monthDuration){
				tenorMin = (loan.activeInterestType.firstPeriod.monthDuration + 12);
			}
			if( loan.tenorUnit === 'YEARS' ) tenorMin = tenorMin / 12;
			input.attr( 'data-slider-min', tenorMin );
			wrapper.find( '[data-min-tenor]' ).html( tenorMin );

			// set maximum
			var tenorMax = loan.activeInterestType.secondPeriod ? loan.activeInterestType.secondPeriod.monthDuration : loan.activeInterestType.firstPeriod.monthDuration;
			if( loan.tenorUnit === 'YEARS' ) tenorMax = tenorMax / 12;
			input.attr( 'data-slider-max', tenorMax );
			wrapper.find( '[data-max-tenor]' ).html( tenorMax );
			

			// rebuild slider
			slider.slider('destroy');
			slider.slider();

			// set default as current value
			input.attr( 'data-slider-value', sliderValue );
			wrapper.find('.qty').val( sliderValue );
			wrapper.find('.valShow').html(sliderValue);
			slider.slider( 'setValue', sliderValue, true );

			// attach slide event
//			slider.on( 'slide', function() {
//				var value = slider.slider('getValue');
//				wrapper.find('.qty').val(value);
//				input.siblings( '.qty' ).trigger('change');
//			} );

		}

	};


	/**
	 * Update Interest Type Select
	 *
	 */
	this.updateInterestTypeSelect = function() {

	       var interestTypes = loan.activeTab.data.interest;
	        var select = $('[data-interest-select]');
	        var html = '';

	        if (select.length) {

	            // clear select
	            select.html('');

	            /* generate select html
	             interestTypes.forEach( function( interestType ) {
	 
	                 var code = interestType.interestCode;
	                 var label = calculatorLabels[code];
	 
	                 if( code === loan.activeInterestType.interestCode ) {
	                     html += '<option value="' + code + '" selected>' + label + '</option>';
	                 } else {
	                     html += '<option value="' + code + '">' + label + '</option>';
	                 }
	 
	             } );
	             */
	            var checkInterestType = "";
	            var countInterestType = 0;
	            var ind = 0;
	            loan.activeVariant.glProductVariantList.forEach(function(variant) {

	                code = variant.variantType;
	                var label = calculatorLabels[code];
	                if (!checkInterestType.includes(label)) {
	                    if (code === loan.activeMortgage.variantType) {
	                        html += '<option value="' + code + '" selected>' + label + '</option>';
	                    } else {
	                        html += '<option value="' + code + '">' + label + '</option>';
	                    }
	                    
	    				$("div[data-algorithm-input=newInterest]", loan.activeCalculator).children().find("input[type=radio]").each(function(index, element){
	    					console.log("index");
	    					if(index == ind){
	    						$(element).val(code);
	    						$(element).parent().find("span").text(label);
	    						$(element).parents(".section__form__inline").css("display", "inline-block");
	    						ind = ind + 1;
	    						return false;
	    					}					
	    				});
	                    checkInterestType = checkInterestType.concat(label + ",");
	                    countInterestType++;
	                }
	            });
	            if (countInterestType == 1) {
	                $('[data-interest-select]').hide();
	                $('[data-interest-row]').hide();
	            }

	            // append option HTML
	            select.append(html);

	        }


	};

	/**
	 * Update Share Calculator Link
	 *
	 */
	this.updateShareCalculatorLink = function() {

		// get url without query string
		var currentURL = window.location.href;
			currentURL = currentURL.split('?');
			currentURL = currentURL[0];

		// var loanpurposeurl = "";

		// if (loan['loanpurpose']!==undefined){
		// 	loanpurposeurl = '&loanpurpose=' + loan['loanpurpose'];
		// }		

		

		// add standard query params
		var queryParams = '?loanAmount=' + loan['loanAmount'] + '&tenor=' + loan['tenor'] + '&currency=' + loan['currency'] + '&interestRateType=' + loan['interestRateType'] + '&mortgage=' + loan['mortgage'];// + loanpurposeurl;
		console.log(queryParams);
		// without salary case
		var isWithoutSalaryTab = $( '[data-tab="without-salary"]' ).hasClass( 'open' );
		if( isWithoutSalaryTab ) queryParams += '&isDefault=false';

		//custom url for data-socialshare
		if ($('[data-socialshare]').length>0){

			$('[data-socialshare]').each(function(){

				//if we are on the homepage, get the clean url when it's shared from the sidebar
				if( $("html").hasClass("home") ){
				
					if (!$(this).parents('.socialShare__calculator').length>0){
						queryParams = "";
					}

				}

				//get the url from the attribute
				// console.log(1);
				if($(this).attr("data-share-url").length>0){
					// console.log(2);
					if($(this).attr("data-share-url")!==""){
						// console.log(3);
						currentURL = $(this).attr("data-share-url"); 
					}
				}

				if ($(this).attr("data-socialshare")=="facebook"){

					$(this).attr("href","https://www.facebook.com/sharer/sharer.php?u="+currentURL + queryParams);

				}
			
				if ($(this).attr("data-socialshare")=="twitter"){

					$(this).attr("href","https://twitter.com/home?status="+currentURL + queryParams);

				}
				
				if ($(this).attr("data-socialshare")=="linkedin"){

					$(this).attr("href","https://www.linkedin.com/sharing/share-offsite/?url="+currentURL + queryParams);

				}

				if ($(this).attr("data-socialshare")=="whatsapp"){

					$(this).attr("href"," https://wa.me/?text="+encodeURIComponent(currentURL) + encodeURIComponent(queryParams));

				}				
				
				if ($(this).attr("data-socialshare")=="mail"){

					$(this).attr("href","mailto:?body="+currentURL + encodeURIComponent(queryParams));

				}				

			});
		}

	};	


	/**
	 * Update Loan Amount Input
	 *
	 */
	this.updateLoanAmountInput = function() {

		var input = $( '[data-algorithm-input="loanAmount"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeTab.data.minimumAmount;
			var maximumAmount = loan.activeTab.data.maxAmountForOnline;
			var defaultAmount = loan.activeTab.data.defaultAmount;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-min]' ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-max]' ).text( max );

			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
			
				input.val( defaultAmount );

			}

			// validate
			input.parsley().validate();

		}

	};
	
	this.updateLoanAmountInputVariant = function() {

		var input = $( '[data-algorithm-input="loanAmount"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeTab.data.minimumAmount;
			var maximumAmount = loan.maxAmountForVariant;//loan.activeTab.data.maxAmountForOnline;
			var defaultAmount = loan.activeTab.data.defaultAmount;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-min]' ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-max]' ).text( max );

			// insert default value if the value is 0
			if (	input.val() == "0"){
			
				input.val( defaultAmount );

			}

			// validate
			input.parsley().validate();

		}

	};


	/**
	 * Set Active Variant
	 *
	 */
	this.setActiveVariant = function() {

		if( loan.activeCalculator ) {

			var calculatorData = loan.activeCalculator.siblings( '.calculatorData' ).val();

			try {

				// get calculator data
				var variantData = JSON.parse( calculatorData );
				loan.activeVariant = variantData.glGenericSimulatorParams;

			} catch(e) {

				console.error( 'Calculator JSON file invalid' );

			}

		}

	};

    this.setActiveVariantUpperMass = function() {

        if (loan.activeCalculator) {

            var calculatorData = loan.activeCalculator.siblings('.calculatorDataUpperMass').val();

            try {

                // get calculator data
                var variantData = JSON.parse(calculatorData);
                loan.activeVariant = variantData.glGenericSimulatorParams;

            } catch (e) {

                console.error('Calculator JSON file invalid');

            }

        }

    };
	
    /**
     * Update Tenor Step
     * 
     *
     */
    this.updateTenorStep = function() {
    	var input = $('.rangeslider.rangeslider--2', loan.activeCalculator);
        var step = loan.activeTab.data.amountList[0].tenorScalingFactor;
        //console.log("sono nel primo step"+step);
        input.attr('data-slider-step', step);
    	
    };
	
	this.updateLoanAmountInputVariant = function() {

		var input = $( '[data-algorithm-input="loanAmount"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeTab.data.minimumAmount;
			var maximumAmount = loan.activeTab.data.maxAmountForOnline;
			var defaultAmount = loan.activeTab.data.defaultAmount;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-min]' ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-max]' ).text( max );

			// insert default value if the value is 0
			if (	input.val() == "0"){
			
				input.val( defaultAmount );

			}

			// validate
			input.parsley().validate();

		}

	};
    
	/**
	 * Set Active Mortgage
	 *
	 */
	this.updateCalculatorConfigurationByTenor = function( currentTenor, defaultValue ) {

		var variantList = loan.activeVariant.glProductVariantList;
		var variantType = ""; 
		var v;
		// cicle all the martgage options
		var foundInterest = false; 

		// cerco in un altra variante un tasso di interesse nel range del tenor
		
		for (k = 0; (k < loan.activeCurrency.glGenericCalculationList.length  || foundInterest); k++){
			
			var c = loan.activeCurrency.glGenericCalculationList[k];
			
			var interestPeriodToCheck = c.interest[0].firstPeriod.monthDuration;
			if(c.interest[0].firstPeriod.monthDuration == null || c.interest[0].firstPeriod.monthDuration == 'null'){
				interestPeriodToCheck = c.interest[1].firstPeriod.monthDuration;
			}
			
			if(c.amountList[0].minimumTenor <= currentTenor && interestPeriodToCheck >=  currentTenor && c.amountList[0].maximumTenor >= currentTenor && c.isDefault == defaultValue) {

				loan.activeTab = {
						'isDefault': c.isDefault,
						'data': c ,
					};
				loan.standard = c.standard;
				foundInterest = true;
				
				break;

			}

		}
		
		if (!foundInterest){
			// se non trovo il tasso di interesse nel range assegno quello di default della variante e aggiorno il tenor	

			for (k = 0; (k < loan.activeCurrency.glGenericCalculationList.length  || foundInterest); k++){
				
				var c = loan.activeCurrency.glGenericCalculationList[k];
				
				if(c.isDefault) {

					loan.activeTab = {
							'isDefault': c.isDefault,
							'data': c ,
						};
					foundInterest = true;
					loan.standard = c.standard;
					
					break;

				}

			}
			
			loan.updateTenorUnit();
//			loan.updateTenorSlider();
			
		}
		loan.updateTenorUnit();
		loan.updateTenorSlider();
		loan.updateTenorStep();
		loan.updateInterestTypeSelect();
		loan['mortgage'] = variantType;
		loan.setActiveInterestType(loan.activeTab.data.interest[0].interestCode)
		loan.updateLoanAmountInputVariant();
	};

	/**
	 * Set Active Mortgage
	 *
	 */
	this.setActiveMortgage = function( value ) {

		var mortgageOptions = loan.activeVariant.glProductVariantList;
		var numberOfMortgage = mortgageOptions.length;

		// cicle all the martgage options
		for( var i = 0; i < numberOfMortgage ; i++ ) {

			if( mortgageOptions[i].variantType === value ) {

				loan.activeMortgage = mortgageOptions[i];
				break;

			}

		}

		loan['mortgage'] = value;

	};


	/**
	 * Get Default Mortgage
	 *
	 */
	this.getDefaultMortgage = function() {

		if( loan.activeVariant ) {

			var mortgageOptions = loan.activeVariant.glProductVariantList;
			var numberOfMortgage = mortgageOptions.length;
			var label = '';
			var mortgageFound = false;

			// cicle all the martgage options
			for( var i = 0; i < numberOfMortgage ; i++ ) {

				if( mortgageOptions[i].default === true ) {

					label = mortgageOptions[i].variantType;
					loan['mortgage'] = label;
					mortgageFound = true;
					break;

				}

			}

			if( !mortgageFound ) label = mortgageOptions[0].variantType;

			loan['mortgage'] = label;

			return label;

		}

	};


	/**
	 * Set Active Currency
	 *
	 */
	this.setActiveCurrency = function( value ) {

		var currencyOptions = loan.activeMortgage.glConfigurationList;
		var numberOfCurrency = currencyOptions.length;

		// cicle all the currencies
		for( var i = 0; i < numberOfCurrency ; i++ ) {

			if( currencyOptions[i].currency === value ) {

				loan.activeCurrency = currencyOptions[i];
				break;

			}

		}

	};


	/**
	 * Get Default Currency
	 *
	 */
	this.getDefaultCurrency = function() {

		var currencyOptions = loan.activeMortgage.glConfigurationList;
		var numberOfCurrency = currencyOptions.length;
		var label = '';

		// cicle all the currencies
		for( var i = 0; i < numberOfCurrency ; i++ ) {

			if( currencyOptions[i].default === true ) {

				label = currencyOptions[i].currency;
				break;

			}

		}

		return label;

	};


	/**
	 * Set Active Interest Type
	 *
	 */
	this.setActiveInterestType = function( value ) {
		var interestOptions = loan.activeTab.data.interest;
		var numberOfInterests = interestOptions.length;

		// cicle all interest rates
		for( var i = 0; i < numberOfInterests ; i++ ) {

			if( interestOptions[i].interestCode === value ) {

				loan.activeInterestType = interestOptions[i];
				loan['interestRateType'] = value;
				break;

			}

		}

	};


	/**
	 * Get Default Interest Type
	 *
	 */
	this.getDefaultInterestType = function() {

		var interestOptions = loan.activeTab.data.interest;
		var numberOfInterests = interestOptions.length;
		var label = '';

		// cicle all interest rates
		for( var i = 0; i < numberOfInterests ; i++ ) {

			if( interestOptions[i].default === true ) {

				label = interestOptions[i].interestCode;
				break;

			}

		}

		return label;

	};


	/**
	 * Get Calculator Inputs
	 *
	 */
	this.getCalculatorInputs = function() {

		var inputs = $( '[data-algorithm-input]', loan.activeCalculator );
		var numberOfInputs = inputs.length;

		for( var i = 0; i < numberOfInputs; i++ ) {

			// get name
			var inputLabel = inputs[i].getAttribute( 'data-algorithm-input' );

			// get value
			var inputValue = inputs[i].value;

			// remove dots from loan amount
			if( inputLabel === 'loanAmount' ) {
				inputValue = inputValue.replace( /\./g, '' ).replaceAll(/\s/g, '');
			}

			// mortgage
			if( inputLabel === 'mortgage' ) {
				inputValue = $('input[name=radio]:checked', '[data-algorithm-input="mortgage"]').val();
			}			

			// parse numbers
			if( inputLabel !== 'currency' &&  inputLabel !== 'mortgage' )	inputValue = parseFloat( inputValue );

			// set global property
			loan[inputLabel] = inputValue;

		}

	};
	
	/**
	 * Update Tabs Number
	 *
	 */
	this.updateTabsNumber = function() {

		var tabs = loan.activeVariant.glGenericCalculationList;
		var numberOftabs = tabs.length;
		var tabsHTML = $( '.com16__tabMenu' );
		var tabsWrapper = $( '.com16__tabContainer' );

		// hide tabs HTML if there's only one tab
		if( numberOftabs <= 1 ) {
			tabsHTML.hide();
			tabsWrapper.css( 'padding-top', '40px' );
		} else {
			tabsHTML.show();
			tabsWrapper.removeAttr("style");
		}

	};


	/**
	 * Append Calculator Outputs
	 *
	 */
	this.appendCalculatorOutputs = function() {

		var outputs = $( '[data-algorithm-output]', loan.activeCalculator );
		var getLoanButton = $( '.com16__buttonCover .btn', loan.activeCalculator );

		// if there are errors
		if ( loan.errorState === true || isNaN(loan.loanAmount) ) {
			$( '[data-algorithm-output]:not([data-algorithm-output=currency])' ).text( '-' );
			getLoanButton.addClass( 'disabled' );
			return;
		}

		// enable button
		getLoanButton.removeClass( 'disabled' );

		outputs.each( function() {

			var inputLabel = $(this).attr('data-algorithm-output');
			var outputValue = loan[inputLabel];

			// format outputs
			if(( inputLabel === 'monthlyInstallment' ) || ( inputLabel === 'firstMonthlyInstallment' )|| ( inputLabel === 'secondMonthlyInstallment' ) || ( inputLabel === 'secondInterestRate' ) || ( inputLabel === 'firstInterestRate' ) ){
				outputValue = number_format( loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator );
			}
			if( inputLabel === 'loanAmount' || inputLabel === 'amountToRepay' || inputLabel === 'aprc' || inputLabel === 'aprc2'){
				outputValue = number_format( loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator );
			} 

			
			if( inputLabel === 'tenor' && loan.tenorUnit === 'YEARS' ) {
				outputValue = loan.tenor / 12;
			}
			
			if( inputLabel === 'approval_cost' ) {
				outputValue = loan.formatFeeOutput( outputValue );
			}
			
			if( inputLabel === 'firstInterestRate' ) {
				outputValue += " % " + loan.activeInterestType.interestCode;
			}
			if( inputLabel === 'firstInterestRateCode' ) {
				if( loan.activeInterestType.interestCode.toUpperCase() == "FIXED"){
					outputValue = calculatorLabels["FIXEDMOBILE"];
				} else {
					outputValue = calculatorLabels["VARIABLEMOBILE"];
				}					
			}
			
			if( inputLabel === 'notary_cost' && loan.isWithMortgage) {
				outputValue = loan.formatFeeOutput( outputValue );
			}
			
			if( inputLabel === 'fee') {
				var feeValue = (parseFloat(loan.loanAmount) * parseFloat(loan.fee))/100;
				outputValue = number_format( feeValue, 2, genericSettings.decimal, genericSettings.separator );
			}
            if (inputLabel === 'customer') {
               	if(outputValue == true){
               		$("[data-show-customer]").attr("data-show-customer", true);
               		$("[data-show-notcustomer]").attr("data-show-notcustomer", false);
               		outputValue = calculatorLabels["WITHSALARYMOBILE"];
               	} else {
               	    $("[data-show-customer]").attr("data-show-customer", false);
               		$("[data-show-notcustomer]").attr("data-show-notcustomer", true);
               		outputValue = calculatorLabels["WITHOUTSALARYMOBILE"];
               	}
            }
            if (inputLabel === 'clientSegment') {
               	if(outputValue == true){
               		$("[data-show-mass]").attr("data-show-mass", true);
               		$("[data-show-uppermass]").attr("data-show-uppermass", false);
               		
               	} else {
               	    $("[data-show-mass]").attr("data-show-mass", false);
               		$("[data-show-uppermass]").attr("data-show-uppermass", true);
               	}
            }
            if (inputLabel == 'currency') {
                $("*[data-layer-loan-currency]").attr("data-layer-loan-currency", loan[inputLabel]);
            }
			$(this).text( outputValue );
			
		} );

	};


	/**
	 * Format Fee Output
	 *
	 */
	this.formatFeeOutput = function( outputValue ) {

		var feeCurrency = $( '[data-fixed-currency]' );

		if( (outputValue === null) || (outputValue === undefined) ) {

			// show 'no fee' label & hide currency
			outputValue = calculatorLabels['NO_FEE'];
			feeCurrency.addClass( 'hide' );

		} else {

			outputValue = number_format( outputValue, 2, genericSettings.decimal, genericSettings.separator );
			// show currency
			feeCurrency.removeClass( 'hide' );

		}

		return outputValue;

	};


	/**
	 * Format Money Inputs
	 *
	 */
	this.formatMoneyInputs = function() {

		var inputToFormat = $( '*[data-format-currency]');

		if( inputToFormat.length ) {

			inputToFormat.each( function() {

				var cleave = new Cleave( $(this), {

					delimiter: genericSettings.separator,
					numeral: true,
					numeralDecimalMark: genericSettings.decimal,
					numeralDecimalScale: 2,
					numeralThousandsGroupStyle: 'thousand'

				} );

			} );

		}

	};

	/**
	 * Calculate the loan payment plan 
	 * returns a matrix as follow 
	 * [
	 * 	   [0: index , 
	 * 		1: total interest payed , 
	 * 		2: montly installment, 
	 * 		3: capital part 
	 * 		4: interest part
	 * 		5: residual debit
	 * 		6: payed debit]
	 *  ...
	 *  ]
	 */
	this.piano = function(loanAmount , loanDurationInYear , interestRate , periodicy) {
		
		// piano di ammortamento
		var piano = [];	
		
		var m = loanAmount;
		var n = loanDurationInYear;
		var perc = interestRate;
		var i = perc / 100;
		
		// periodicità dei pagamenti: 12: mensile, 
		var k = (!periodicy) ? 12 : periodicy;

		// numero totale di pagamenti
		var kn = k * n;

		// tasso di interesse periodico
		var ik = i / k;

		var ikpiu1 = ik + 1

		// calcolo della rata sulla 
		var rata = m * ik / (1 - Math.pow(ikpiu1, -k * n));

		// rata arrotondata a 2 decimali 
		rata = round(rata , 2);
		
		i = 0;
		// quota interessi 
		var Ii = 0;

		// Interessi totali 
		var ITot = 0;

		// quota capitale 
		var Ci = 0;

		// Debito residuo 
		var Di = m; 

		// Debito Estinto 
		var Ei = 0;

		// calcolo del piano di ammortamento 
		for (i = 1; i <= kn; i++) {

			Ii = round(ik * Di 	, 2);
			Ci = round(rata - Ii, 2);
			Di = round(Di - Ci 	, 2);
			Ei 	= round(Ei + Ci 	, 2);
			ITot = round(ITot + Ii , 2);

			// gestione ultima rata
			if (i == kn){
				rata = round(rata + Di , 2);
				Ei = round( Ei + Di , 2);
				Ci = round(Ci + Di , 2);
				Di = 0;
			}

			piano.push([
				i
				, ITot 
				, rata
				, Ci 
				, Ii 
				, Di 
				, Ei
			]);

		}

		return piano;

	};


	/**
	 * Get the montly installment from paymentDetail
	 * paymentDetail: is a row of the payment plan calculated by loan.piano
	 * montlyinstallment (rata) is the second element of paymentDetail array  
	 *
	 */
	this.getRata = function(paymentDetail) {
		return paymentDetail[2];
	}

	/**
	 * Get the residual debit from paymentDetail
	 * paymentDetail: is a row of the payment plan calculated by loan.piano
	 * residual debit is the 5th element of paymentDetail array  
	 *
	 */
	this.getDebitoRes = function(paymentDetail) {
		return (paymentDetail && paymentDetail[5] && paymentDetail[5] >= 0) ? paymentDetail[5] : 0;
	};

	/**
	 * Calculate Amount To Repay
	 *
	 */
	this.calculateAmountToRepay = function() {
		var initialExpenses = loan.getInitialExpenses(loan.loanAmount , loan.fee , loan.notaryCost , loan.isWithMortgage);
		loan.amountToRepay = initialExpenses;
		
		for (i = 0; i < loan.p.length;  i++){
			loan.amountToRepay += loan.getRata(loan.p[i]);
		}
	};


	/**
	 * Calculate APRC
	 * 
	 */
	this.calculateAPRC_ = function(initialExpenses , periodicExpenses){
			loan.aprc = loan.calcAprc(loan.paymentsHistoryFirstPeriod , (loan.loanAmount - initialExpenses));
			loan.aprc = loan.aprc * 100;  
	}



	/**
	 * Calculate APRC
	 *
	 */
	this.calculateAPRC = function(initialExpenses,periodicExpenses) {

		var m = loan.loanAmount;
		if (m<0) return;
		var si = initialExpenses;
		if (si<0) return;
		var r = loan.firstMonthlyInstallment;
		if (r<0) return;
		var sa = periodicExpenses;
		if (sa<0) return;
		var n = loan.tenor / 12;
		if (n==0) return;
		var k = 12; 
		if (k==0) return;

		rapporto = (m-si)/(r+sa);
		nk = n*k;
		if (rapporto>=nk)
			{
				return undefined;
			}
		var ik = loan.bisezione(0.00000000000001,1);
		var ia = Math.pow(1+ik,k)-1;// tasso effettivo annuo
		ia *=100; 
		loan.aprc = ia; 

	};


	/**
	 * Calculate APRC2
	 *
	 */
	this.calculateAPRC2 = function(initialExpenses,periodicExpenses) {

		var is2PeriodLoan = loan.activeInterestType.periods === 2 && loan.activeInterestType.secondPeriod !== undefined;
		if(is2PeriodLoan && loan.paymentsHistoryWholePeriod && loan.paymentsHistoryWholePeriod.length) {
			
			loan.aprc2 = loan.calcAprc(loan.paymentsHistoryWholePeriod , (loan.loanAmount - initialExpenses));
			loan.aprc2 = (loan.aprc2 * 100);  
		} else{
			loan.aprc2 = 0;
		}
		loan.aprc2 = loan.aprc2;

	};	

	/**
	 * Bisezione 
	 *
	 */
	this.bisezione = function(a,b) {
		fa = loan.f(a);
		if (fa==0) return a;
		fb = loan.f(b);
		if (fb==0) return b;
		m = (a+b)/2;
		fm = loan.f(m);
		if (fm==0) return m;
		if ((b-a)<1e-8) return m;
		if (fa*fm<0) 
			return loan.bisezione(a,m)
		else
			return loan.bisezione(m,b);
	};

	/**
	 * f(x) 
	 *
	 */
	this.f = function(x) {
		return (1-rapporto*x)*Math.pow(1+x,nk)-1;
	};
	
	/**
	 * Format 
	 *
	 */
	this.format = function(n) {

		var nn = Math.round(n*1000)/1000;
		var s = String(nn);
		var l = s.length;
		var punto = s.indexOf('.');
		if (punto<0) s +='.00';
		if (punto==l-1) s +='00';
		if (punto==l-2) s +='0';
		punto = s.indexOf('.');
		s = s.substr(0,punto+3);
		return s;
	}
	
	
	
	this.setActiveTabByVal = function( defaultValue, forceOpenTab , tab ) {

		// prevent not boolean values
		var tabDefaultValue = defaultValue === false ? false : true;

		// force open tab if not already open
		if( forceOpenTab ) {
			var isTabOpen = $( '[data-tab-default="' + tabDefaultValue + '"]' ).parent().hasClass( 'open' );
			if( !isTabOpen ) $( '[data-tab-default="' + tabDefaultValue + '"]' ).trigger( 'click' );
		}
		
		if (tab){
			loan.activeTab = {
					'isDefault': tab.isDefault,
					'data': tab.data ,
				};
			loan.standard = tab.standard;
			return;
		}
		

		// get active variant tabs array
		var tabs = loan.activeCurrency.glGenericCalculationList;
		var numberOftabs = tabs.length;
		var tabFound = false;

		for( var i = 0; i < numberOftabs ; i++ ) {

			var isDefaultTab = tabs[i].isDefault;

			// if isDefault == true, set it
			if( isDefaultTab && isDefaultTab == defaultValue) {
				loan.activeTab = {
					'isDefault': tabs[i].isDefault,
					'data': tabs[i] ,
				};
				loan.standard = tabs[i].standard;
				var tabFound = true;
				break;
			}

		}

		// if tab not founded set default
		if( !tabFound ) {
			loan.activeTab = {
				'isDefault': tabs[0].isDefault,
				'data': tabs[0] , 
			};
			loan.standard = tabs[0].standard;
		}

	};
	/**
	 * Set Active Tab
	 *
	 */
	this.setActiveTab = function( defaultValue, forceOpenTab , tab ) {

		// prevent not boolean values
		var tabDefaultValue = defaultValue === false ? false : true;

		// force open tab if not already open
		if( forceOpenTab ) {
			var isTabOpen = $( '[data-tab-default="' + tabDefaultValue + '"]' ).parent().hasClass( 'open' );
			if( !isTabOpen ) $( '[data-tab-default="' + tabDefaultValue + '"]' ).trigger( 'click' );
		}
		
		if (tab){
			loan.activeTab = {
					'isDefault': tab.isDefault,
					'data': tab ,
				};
			loan.standard = tab.standard;
			return;
		}
		

		// get active variant tabs array
		var tabs = loan.activeCurrency.glGenericCalculationList;
		var numberOftabs = tabs.length;
		var tabFound = false;

		for( var i = 0; i < numberOftabs ; i++ ) {

			var isDefaultTab = tabs[i].isDefault;

			// if isDefault == true, set it
			if( isDefaultTab && isDefaultTab == defaultValue) {
				loan.activeTab = {
					'isDefault': tabs[i].isDefault,
					'data': tabs[i] ,
				};
				loan.standard = tabs[i].standard;
				var tabFound = true;
				break;
			}

		}

		// if tab not founded set default
		if( !tabFound ) {
			loan.activeTab = {
				'isDefault': tabs[0].isDefault,
				'data': tabs[0] , 
			};
			loan.standard = tabs[0].standard;
		}

	};

	/**
	 * Console Log Values
	 *
	 */
	this.consoleLogValues = function() {

		console.log( '--------------------------------------' );
		console.log( 'Active variant | ' + loan.activeVariant.productCategory );
		console.log( 'Active mortgage | ' + loan.activeMortgage.variantType );
		console.log( 'Currency | ' + loan.currency );
		console.log( 'Active interestType | ' + loan.activeInterestType.interestCode );
		console.log( 'Loan amount | ' + loan.loanAmount );
		console.log( 'First Interest Rate | ' + loan.firstInterestRate );
		console.log( 'Second Interest Rate | ' + loan.secondInterestRate );
		console.log( 'Tenor in months | ' + loan.tenor );
		console.log( 'Tenor unit | ' + loan.tenorUnit );
		console.log( 'Amount to repay | ' + loan.amountToRepay );
		console.log( 'Monthly installment first | ' + loan.firstMonthlyInstallment );
		console.log( 'Monthly installment second | ' + loan.secondMonthlyInstallment );
		console.log( 'APR | ' + loan.apr );
		console.log( 'APRC | ' + loan.aprc );
		console.log( 'Fee (Approval Cost) | ' + loan.fee + "%");
		console.log( 'Min Approval Cost | ' + loan.min_approval_cost);
		console.log( 'Max Approval Cost | ' + loan.max_approval_cost);
		console.log( 'Notary Cost | ' + loan.notaryCost );
		console.log( '--------------------------------------' );

	};
};

/**
 * Get class instance
 *
 */
Intesa.LoanCalculatorBIBCombined.getInstance = function() {

    if (!window.intesa) {

        window.intesa = new Object();

    }

    if (!window.intesa.loan_calculator_bib_combined) {

        window.intesa.loan_calculator_bib_combined = new Intesa.LoanCalculatorBIBCombined();

    }

    return window.intesa.loan_calculator_bib_combined;

};
